import { Spin } from "antd";

const SpinLoader = ({
  tip = "",
  spinning,
  spinOverlayBg = "rgba(0, 0, 0, 0.5)",
  size, // small, default, or large
  wrapperClassName = "custom-spin-overlay",
  ...props
}) => {
  return (
    <>
      <style>
        { `.custom-spin-overlay .ant-spin-container::after {
            background-color: ${spinOverlayBg};
          }`
        }
      </style>
      <Spin
        {...props}
        spinning={spinning}
        size={size}
        tip={tip}
        wrapperClassName={wrapperClassName} // Custom class for scoped styling
      />
    </>
  );
};

export default SpinLoader;
